// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-file-element',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        schema: {
            type: Object,
            required: false,
            default: undefined,
        },
        schemaData: {
            type: Object,
            required: false,
            default: undefined,
        },
        content: {
            type: Object,
            required: false,
            default: undefined,
        },
        data: {
            type: Object,
            required: false,
            default: undefined,
        },
    },
    data: () => ({}),
    computed: {
        field() {
            return this.content?.fields[0];
        },
        caption() {
            if (!this.element) {
                return null;
            }
            if (this.element.isOptional) {
                return this.element.label + ' (Optional)';
            }
            else {
                return this.element.label;
            }
        },
        element() {
            return this.content?.element;
        },
    },
    // #endregion
    // #region Core
    methods: {
        getValueOrAttribute(value, name) {
            if (value) {
                return value;
            }
            let tAtt = this.schema.attributes.find((e) => e.name === name);
            if (tAtt) {
                return tAtt.value;
            }
            return undefined;
        },
        onFilesChanged() {
            this.$emit("command", "commit");
        }
    }
    // #endregion
});
// #endregion
